// extracted by mini-css-extract-plugin
module.exports = {"postLink":"HyperLink_postLink__1g4zg"};